"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
var http_adapter_1 = require("./http.adapter");
var AxiosAdapter = /** @class */ (function () {
    function AxiosAdapter(baseURL) {
        this.headers = {
            'Content-Type': 'application/json',
        };
        this.api = axios_1.default.create({
            baseURL: baseURL,
        });
    }
    AxiosAdapter.prototype.setBearerAuthorization = function (token) {
        this.headers = __assign(__assign({}, this.headers), { Authorization: "Bearer " + token });
    };
    AxiosAdapter.prototype.get = function (url, config) {
        return __awaiter(this, void 0, void 0, function () {
            var err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.get(url, this._applyHeaders(config))];
                    case 1: return [2 /*return*/, (_a.sent()).data];
                    case 2:
                        err_1 = _a.sent();
                        throw AxiosAdapter._handleException(err_1);
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    AxiosAdapter.prototype.post = function (url, data, config) {
        return __awaiter(this, void 0, void 0, function () {
            var err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.post(url, data, this._applyHeaders(config))];
                    case 1: return [2 /*return*/, (_a.sent()).data];
                    case 2:
                        err_2 = _a.sent();
                        throw AxiosAdapter._handleException(err_2);
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    AxiosAdapter.prototype.put = function (url, data, config) {
        return __awaiter(this, void 0, void 0, function () {
            var err_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.put(url, data, this._applyHeaders(config))];
                    case 1: return [2 /*return*/, (_a.sent()).data];
                    case 2:
                        err_3 = _a.sent();
                        throw AxiosAdapter._handleException(err_3);
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    AxiosAdapter.prototype.patch = function (url, data, config) {
        return __awaiter(this, void 0, void 0, function () {
            var err_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.patch(url, data, this._applyHeaders(config))];
                    case 1: return [2 /*return*/, (_a.sent()).data];
                    case 2:
                        err_4 = _a.sent();
                        throw AxiosAdapter._handleException(err_4);
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    AxiosAdapter.prototype.delete = function (url, config) {
        return __awaiter(this, void 0, void 0, function () {
            var err_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.delete(url, this._applyHeaders(config))];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        err_5 = _a.sent();
                        throw AxiosAdapter._handleException(err_5);
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    AxiosAdapter.prototype._applyHeaders = function (config) {
        return __assign(__assign({}, config), { headers: __assign(__assign({}, this.headers), config === null || config === void 0 ? void 0 : config.headers) });
    };
    AxiosAdapter._handleException = function (err) {
        if (err.response && err.response.data && err.response.data.statusCode === 400) {
            return new http_adapter_1.BadRequestError(err.response && err.response.data
                ? err.response.data.message
                    ? err.response.data.message
                    : err.response.data
                : err.message);
        }
        return new Error(err.response && err.response.data
            ? err.response.data.message
                ? err.response.data.message
                : err.response.data
            : err.message);
    };
    return AxiosAdapter;
}());
exports.default = AxiosAdapter;
